export const SHARED_CONSTANT = {
  DOWNLOAD_FILE: "",
  VISITOR_SEARCH: "/visitor/search",
  CAST: "/visitor/cast/subcast",
  SEARCH_BY_VOTER_ID: "/voter/search",
  SEARCH_BY_GENERAL: "/voter/search",
  SEARCH_BY_PHONE: "/voter/search",
  SEARCH_RESULT_TABLE_CONFIG:
    "/assets/page-configs/voter-search-result-list.json",
  ASSEMBLIES_LIST: "/common/assemblies",
  GAON_LIST: "/common/gaon",
  GAON_LIST_WITH_ASSEMBLY: "/common/gaon/assembly",
  GATNO_LIST: "/common/gatData",
  GAN_NUMBER_LIST: "/common/gan",
  PRABHAG_LIST: "/common/prabhag",
  PRABHAG_AREA_LIST: "/common/prabhagArea",
  DOCUMENT_DOWNLOAD: "/file-uploader/downloadS3?path=",
  PERMISSION: "/assets/json/mock/permission.json",
  CHECK_EXISTING_NUMBER:"/visitor/checkPhone",
  GET_AREA_NAGAR_LIST:"/voter/search/getVoterArea/list",
  GET_SOCIETY_VASTI_LIST:"/voter/search/getVoterSociety/list",
};

export const EXCEL_COLUMNS = {
  COLUMNS_LENTHS: [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "x",
    "Y",
    "Z",
  ],
};
